var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import i18next from "i18next";
import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import assign from "lodash/assign";
import orderBy from "lodash/orderBy";
import { BookModel } from "..";
import { currency } from "../../../helpers";
import { PriceModelCollection } from "./PriceModelCollection";
import { CART_ITEMS_PATH } from "../../../components/BookingForm/booking-form.helpers";
var PriceModel = /** @class */ (function (_super) {
    __extends(PriceModel, _super);
    function PriceModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.parent_price_id = null;
        return _this;
    }
    PriceModel.getCollectionClass = function () {
        return PriceModelCollection;
    };
    Object.defineProperty(PriceModel.prototype, "priceIncludingSubPrices", {
        get: function () {
            return this.getSubPriceSumTotal();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "isCourseTimespan", {
        get: function () {
            return "courseTimespan" === this.get("relation_name");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "priceAsTitleWithPlacesLeft", {
        get: function () {
            return this.getPriceAsTitle(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "priceAsTitleWithoutPlacesLeft", {
        get: function () {
            return this.getPriceAsTitle(false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "extraPriceAsTitleWithPlacesLeft", {
        get: function () {
            return this.getPriceAsTitle(true, "bookcart.extraprice_label");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "extraPriceAsTitleWithoutPlacesLeft", {
        get: function () {
            return this.getPriceAsTitle(false, "bookcart.extraprice_label");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "max_bookable_places_left", {
        get: function () {
            var places_left = this.get("places_left");
            return this.options.disableAvailabilityCheck ? Math.max(places_left, this.get("max_quantity")) : places_left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "max_quantity_left", {
        get: function () {
            if (this.options.disableAvailabilityCheck) {
                return this.get("max_bookable_places_left");
            }
            return this.get("quantity_left");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "maxCourseQuantity", {
        get: function () {
            return this.get("maximum_quantity");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "minCourseQuantity", {
        get: function () {
            return this.get("minimum_quantity");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceModel.prototype, "title", {
        get: function () {
            return this.get("presented.customerTitle");
        },
        enumerable: false,
        configurable: true
    });
    PriceModel.prototype.getComputedPrice = function (form) {
        var _this = this;
        var priceModel = this;
        var cartItems = get(form, CART_ITEMS_PATH, []).map(function (item) { return (__assign({ price_id: null, quantity: null }, get(item, "position", {}))); }).filter(function (_a) {
            var price_id = _a.price_id, quantity = _a.quantity;
            return price_id && +quantity;
        });
        var sum = cartItems.reduce(function (sum, _a) {
            var price_id = _a.price_id, quantity = _a.quantity;
            var model = ((+price_id === +_this.id) ? priceModel : priceModel === null || priceModel === void 0 ? void 0 : priceModel.extraPrices().findById(price_id));
            return model ? currency(model === null || model === void 0 ? void 0 : model.getSubPriceSumTotal()).multiply(quantity).add(sum).value : sum;
        }, 0);
        return this.formatPrice(sum);
    };
    PriceModel.prototype.getSubPriceSumTotal = function () {
        var subPrices = this.getAllSubPrices();
        return subPrices.reduce(function (sumTotal, subPrice) { return sumTotal + (subPrice.get("price") || 0); }, this.get("price") || 0);
    };
    PriceModel.prototype.getSubPriceSumTotalFormatted = function () {
        return this.formatPrice(this.getSubPriceSumTotal());
    };
    PriceModel.prototype.getAllSubPrices = function () {
        var allSubprices = [];
        var relatedSubPrices = this.subPrices().all();
        // recursive to every subprices if any. pass the new list
        relatedSubPrices.forEach(function (price) {
            allSubprices.push(price);
            allSubprices.push.apply(allSubprices, price.getAllSubPrices());
        });
        return allSubprices;
    };
    PriceModel.prototype.subPrices = function () {
        return this.hasMany("prices", 'subPrices');
    };
    PriceModel.prototype.extraPrices = function () {
        return this.hasMany("prices", 'customerExtraPrices');
    };
    PriceModel.prototype.withParentPriceId = function (parent) {
        assign(this, { "parent_price_id": (parent === null || parent === void 0 ? void 0 : parent.id) || null });
        return this;
    };
    PriceModel.prototype.getNestedExtraPrices = function (itemsMapById, rootParentId) {
        if (itemsMapById === void 0) { itemsMapById = {}; }
        var getExtraPrices = function (price) { return price.extraPrices().all().map(function (p) { return p.withParentPriceId(price); }); };
        var nestedPrices = getExtraPrices(this).reduce(function (extraPrices, extraPrice) {
            var extraPriceChildren = +get(itemsMapById[extraPrice.id], "position.quantity", 0) ? getExtraPrices(extraPrice) : [];
            return extraPrices.concat(extraPrice, extraPriceChildren);
        }, []);
        nestedPrices = !rootParentId ? nestedPrices : orderBy(nestedPrices, function (value) { return Number(String(value.parent_price_id) !== String(rootParentId)); });
        return uniqBy(nestedPrices, function (x) { return x.id; });
    };
    PriceModel.prototype.getPriceAsTitle = function (showFreePlaces, prop) {
        if (showFreePlaces === void 0) { showFreePlaces = true; }
        if (prop === void 0) { prop = "bookcart.price_label"; }
        var quantity_left = this.get("quantity_left");
        var booking_count = this.get("booking_count");
        var max_quantity = this.get("max_bookable_places_left");
        var placesLeft = quantity_left <= 0
            ? i18next.t("bookcart.fully_booked", { booking_count: booking_count, max_quantity: max_quantity })
            : i18next.t("bookcart.n_places_left", {
                count: max_quantity,
                max_quantity: max_quantity,
                booking_count: booking_count
            });
        return i18next.t(prop, {
            price: this.getSubPriceSumTotalFormatted(),
            title: this.get("presented.customerTitle"),
            quantity_left: showFreePlaces && this.get("show_free_places") ? placesLeft : ''
        });
    };
    PriceModel.prototype.getExtraPricesAsSelect = function (count, itemsMapById, rootParentId) {
        var _this = this;
        if (itemsMapById === void 0) { itemsMapById = {}; }
        var bookers_count = +get(itemsMapById[this.id], "position.quantity");
        return this.getNestedExtraPrices(itemsMapById, rootParentId).filter(function (m) { return m.id !== _this.id; }).map(function (m) {
            var disableCheck = _this.options.disableAvailabilityCheck;
            var quantityLeftProp = disableCheck ? "max_bookable_places_left" : "quantity_left";
            var quantity_left = Math.max(+m.get(quantityLeftProp), 0);
            var optionCount = Math.min(quantity_left, bookers_count, count);
            if (!m.isCourseTimespan)
                optionCount = quantity_left;
            else if (disableCheck)
                optionCount = bookers_count;
            var _a = _this.options.isAdminIntegration ? [1, 0] : [0, 1], optionsOffset = _a[0], labelOffset = _a[1];
            var selectOptions = new Array(+optionCount + optionsOffset).fill(null).map(function (x, i) { return i + labelOffset; });
            return {
                label: m.extraPriceAsTitleWithPlacesLeft,
                options: selectOptions,
                children: _this.options.isAdminIntegration ? null : m.get("presented.body"),
                id: "" + m.get("id"),
                disabled: m.isCourseTimespan && optionCount === 0
            };
        });
    };
    PriceModel.prototype.formatPrice = function (price) {
        return currency(price).format();
    };
    PriceModel.prototype.getFormattedPrice = function () {
        return this.formatPrice(this.get("price"));
    };
    PriceModel.prototype.getAsRowItem = function (quantity) {
        return {
            quantity: quantity,
            id: this.id,
            price: this.getFormattedPrice(),
            sumTotal: currency(this.get("price")).multiply(quantity).value,
            sumTotalFormatted: currency(this.get("price")).multiply(quantity).format(),
            title: this.get("presented.customerTitle"),
        };
    };
    PriceModel.prototype.getAsSelectOptions = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.label, label = _c === void 0 ? "" : _c, _d = _b.value, value = _d === void 0 ? "id" : _d;
        return {
            label: label ? this.get(label) : this.priceAsTitleWithPlacesLeft,
            value: "" + this.get(value),
        };
    };
    return PriceModel;
}(BookModel));
export { PriceModel };
